import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const Marketplaces = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 20 }, forwardedRef) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        ref={forwardedRef}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.6039 2.86131C11.527 1.90217 13.0441 1.89413 13.9692 2.85534C14.8785 3.80017 14.8712 5.32598 13.9634 6.26918C13.7437 6.49749 13.4379 6.67449 13.1681 6.80779C13.0774 6.85256 12.9832 6.89604 12.8869 6.93807H17.4182C17.7395 6.93807 18 7.19856 18 7.51989V10.0078C18 10.3291 17.7395 10.5896 17.4182 10.5896H2.58182C2.26049 10.5896 2 10.3291 2 10.0078V7.51989C2 7.19856 2.26049 6.93807 2.58182 6.93807H7.1131C7.01682 6.89604 6.92259 6.85256 6.83195 6.80779C6.5621 6.67449 6.25628 6.49749 6.03655 6.26918C5.12879 5.32598 5.12147 3.80017 6.03081 2.85534C6.95591 1.89413 8.47297 1.90217 9.39608 2.86131C9.61571 3.08951 9.78488 3.40368 9.91274 3.68264C9.94246 3.74748 9.97156 3.8141 10 3.88196C10.0284 3.8141 10.0575 3.74748 10.0873 3.68264C10.2151 3.40368 10.3843 3.08951 10.6039 2.86131ZM12.8884 3.8955C12.5586 3.5528 12.0229 3.55004 11.6847 3.90147C11.6471 3.94054 11.5628 4.06349 11.4509 4.30762C11.3468 4.53474 11.2436 4.81091 11.1471 5.10236C11.0356 5.43946 10.9387 5.77987 10.8644 6.05973C11.1251 5.98387 11.4359 5.88699 11.7436 5.77674C12.0235 5.67642 12.2876 5.56966 12.5037 5.46293C12.7365 5.34793 12.8493 5.26368 12.8827 5.22902C13.2362 4.86174 13.2341 4.25468 12.8884 3.8955ZM3.53557 17.8623C3.21425 17.8623 2.95376 17.6018 2.95376 17.2805V11.8126H17.1117V17.2805C17.1117 17.6018 16.8512 17.8623 16.5298 17.8623L3.53557 17.8623ZM8.31532 3.90147C7.97708 3.55004 7.4414 3.5528 7.11158 3.8955C6.7659 4.25468 6.76384 4.86174 7.11732 5.22902C7.15068 5.26368 7.26348 5.34793 7.49628 5.46293C7.71236 5.56966 7.9765 5.67642 8.25642 5.77674C8.56405 5.88699 8.87488 5.98387 9.13556 6.05973C9.06128 5.77987 8.9644 5.43946 8.85287 5.10236C8.75644 4.81091 8.65324 4.53474 8.54914 4.30762C8.43725 4.06349 8.35292 3.94054 8.31532 3.90147Z"
          fill="url(#paint0_linear_2721_29287)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_2721_29287"
            x1="10"
            y1="2.13818"
            x2="10"
            y2="17.8623"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FF842B" />
            <stop offset="1" stopColor="#D65A00" />
          </linearGradient>
        </defs>
      </svg>
    )
  },
)

export default Marketplaces
